module.exports = "./static/logo.43268407.png";